import { cIC, rIC } from 'idlization'

export function createIC(
  callback: IdleRequestCallback,
  options?: IdleRequestOptions,
) {
  const handler = rIC(callback, options)

  return () => {
    cIC(handler)
  }
}
